import { render, staticRenderFns } from "./viewGuardian.vue?vue&type=template&id=5bf97395&scoped=true&"
import script from "./viewGuardian.vue?vue&type=script&lang=js&"
export * from "./viewGuardian.vue?vue&type=script&lang=js&"
import style0 from "./viewGuardian.vue?vue&type=style&index=0&id=5bf97395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf97395",
  null
  
)

export default component.exports